import { useMedia } from "@/hooks/use-media";
import routes from "@/routers/routes";
import { Form } from "@/ui/form";
import {
    forgetPasswordSchema,
    ForgetPasswordSchema,
} from "@/validators/forget-password.schema";
import { useState } from "react";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { Button, Input, Text } from "rizzui";

const initialValues = {
    email: "",
};

export default function ForgetPasswordForm() {
    const isMedium = useMedia("(max-width: 1200px)", false);
    const [reset, setReset] = useState({});
    const onSubmit: SubmitHandler<ForgetPasswordSchema> = (data) => {
        toast.success(
            <Text>
                Reset link sent to this email:{" "}
                <Text as="b" className="font-semibold">
                    {data.email}
                </Text>
            </Text>,
        );
        setReset(initialValues);
    };

    return (
        <>
            <Form<ForgetPasswordSchema>
                validationSchema={forgetPasswordSchema}
                resetValues={reset}
                onSubmit={onSubmit}
                useFormProps={{
                    defaultValues: initialValues,
                }}
            >
                {({ register, formState: { errors } }) => (
                    <div className="space-y-5">
                        <Input
                            type="email"
                            size={isMedium ? "lg" : "xl"}
                            label="Email"
                            placeholder="Enter your email"
                            rounded="pill"
                            className="[&>label>span]:font-medium"
                            {...register("email")}
                            error={errors.email?.message as string}
                        />
                        <Button
                            className="border-primary-light w-full border-2 text-base font-medium"
                            type="submit"
                            size={isMedium ? "lg" : "xl"}
                            rounded="pill"
                        >
                            Reset Password
                        </Button>
                    </div>
                )}
            </Form>
            <Text className="mt-5 text-center text-[15px] leading-loose text-gray-500 lg:text-start xl:mt-7 xl:text-base">
                Don’t want to reset?{" "}
                <Link
                    to={routes.auth.signIn2}
                    className="font-semibold text-gray-700 transition-colors hover:text-blue"
                >
                    Sign In
                </Link>
            </Text>
        </>
    );
}
